class LoadBasicApiDataError extends Error {
    constructor({errorMessage, errorStepName, errorData}) {
        super(errorMessage);
        this.name = "LoadBasicApiDataError";
        this.errorStep = errorStepName;
        this.errorData = errorData;
    }
}

export default LoadBasicApiDataError;



//////////////////
// WEBPACK FOOTER
// ./src/hooks/LoadBasicApiDataError.js
// module id = rgs+
// module chunks = 1